import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { FormikFormGroup } from "components/common";
const DEFAULT_HIGH_WATERMARK = 95;
const ArchiveBackendFSFieldGroup = () => {
  const {
    values: { id, settings },
    setFieldValue
  } = useFormikContext();
  const highWatermark = settings.high_watermark;
  useEffect(() => {
    if (!id && highWatermark === void 0) {
      setFieldValue("settings.high_watermark", DEFAULT_HIGH_WATERMARK);
    }
  }, [id, highWatermark, setFieldValue]);
  return /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.high_watermark",
      type: "number",
      min: 1,
      max: 100,
      label: "Disk usage high watermark (%)",
      help: "Archiving stops with an error once disk usage on the output path's filesystem reaches this percentage, preventing archives from filling the partition. Set to 100 to effectively disable the limit.",
      required: true,
      labelClassName: "",
      wrapperClassName: ""
    }
  );
};
export default ArchiveBackendFSFieldGroup;
